var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DatePicker } from '@juvare/common-form-ui/DatePicker';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getDataValue, removeDataValue, setDataValue } from '@juvare/json-data-util';
import React from 'react';
import { removeValuesFromComponentDependencies } from '../utils/deleteComponentDependencies';
export const QuickFilterDatePicker = (_a) => {
    var _b;
    var { dataPath, label, filterData, onChangeFilterData, filterDependencies } = _a, props = __rest(_a, ["dataPath", "label", "filterData", "onChangeFilterData", "filterDependencies"]);
    const value = (_b = getComponentValue(filterData, dataPath)) !== null && _b !== void 0 ? _b : {};
    return (React.createElement(DatePicker, { label: label, size: 'small', value: value, hideLabel: true, onChange: (newValue) => {
            if (value !== newValue) {
                onChangeFilterData((prevFilterData) => setComponentValue(prevFilterData, dataPath, newValue.date, filterDependencies));
            }
        }, sx: {
            flex: '1 1 0',
            minWidth: 0,
            '& label.MuiFormLabel-root': {
                top: 2,
            },
            '& label.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink': {
                top: 0,
            },
            '& input.MuiOutlinedInput-input.MuiInputBase-inputSizeSmall': {
                // adding 2px to so that height is 42px instead of 40px
                paddingTop: '12.25px', // magic value = 11.25px (value from JuvareTheme) + 1px
                paddingBottom: '12.25px', // magic value = 11.25px (value from JuvareTheme) + 1px
            },
            '& input::placeholder': {
                typography: 'body2',
                color: themeColors.text.subtle,
                opacity: 1,
                textOverflow: 'ellipsis',
            },
        }, "data-test": props['data-test'] }));
};
function setComponentValue(data, dataPath, value, dependencyMap) {
    const newData = JSON.parse(JSON.stringify(data !== null && data !== void 0 ? data : {}));
    if (value != null) {
        setDataValue(newData, dataPath, value);
    }
    else {
        removeDataValue(newData, dataPath);
        removeValuesFromComponentDependencies(newData, dataPath, dependencyMap);
    }
    return newData;
}
function getComponentValue(data, dataPath) {
    const value = data ? getDataValue(data, dataPath) : undefined;
    if (value && typeof value == 'string') {
        return { date: value };
    }
    else if (value != null) {
        return value;
    }
    else {
        return undefined;
    }
}
